// المسار: src/App.js
import React, { useState, useEffect } from 'react';
import Tracking from './Tracking';
import AdminPanel from './AdminPanel';
import Store from './Store';
import Cart from './Cart';
import Ticker from './Ticker';
import Footer from './Footer';
import Header from './Header'; 
import FloatingWhatsApp from './FloatingWhatsApp'; 
import ImageSlider from './ImageSlider'; 
import Reviews from './Reviews'; 
import { ordersData, productsData } from './data';

function App() {
  const [page, setPage] = useState('home');
  // 1. إصلاح الدخول: حفظ حالة المدير في المتصفح لكي لا يخرج عند التحديث
  const [isAdmin, setIsAdmin] = useState(() => localStorage.getItem("isAdmin") === "true");
  
  const [darkMode, setDarkMode] = useState(false);
  const [lang, setLang] = useState('ar'); 

  // القاموس
  const t = {
    ar: { welcome: "مرحباً بك في عالم CPE Tech", subtitle: "وجهتك الأولى للصيانة الاحترافية وملحقات الأجهزة", store: "المتجر الإلكتروني", storeDesc: "تصفح أحدث الملحقات والشواحن", track: "تتبع جهازي", trackDesc: "اعرف حالة صيانة هاتفك", admin: "دخول الموظفين", adminDesc: "إدارة الطلبات والمنتجات", help: "هل تحتاج مساعدة؟", contact: "اتصل بنا", back: "عودة للرئيسية", added: "تمت الإضافة للسلة" },
    fr: { welcome: "Bienvenue chez CPE Tech", subtitle: "Votre destination pour la maintenance professionnelle", store: "Boutique en ligne", storeDesc: "Accessoires et chargeurs originaux", track: "Suivre mon appareil", trackDesc: "Vérifiez l'état de réparation", admin: "Accès Staff", adminDesc: "Gestion des commandes & produits", help: "Besoin d'aide ?", contact: "Contactez-nous", back: "Retour", added: "Ajouté au panier" }
  };

  // البيانات
  const [allOrders, setAllOrders] = useState(() => JSON.parse(localStorage.getItem("orders")) || ordersData);
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("cart")) || []);
  const [products, setProducts] = useState(() => JSON.parse(localStorage.getItem("products")) || productsData);
  // حماية ضد الانهيار (reviews || [])
  const [reviews, setReviews] = useState(() => JSON.parse(localStorage.getItem("reviews")) || [{id:1, name:"أحمد", comment:"خدمة ممتازة", rating:5}]);
  
  // 2. إصلاح كلمة السر: التأكد من قراءتها كنص
  const [adminPass, setAdminPass] = useState(() => {
    return localStorage.getItem("adminPass") || "1234";
  });

  // الحفظ
  useEffect(() => { localStorage.setItem("orders", JSON.stringify(allOrders)); }, [allOrders]);
  useEffect(() => { localStorage.setItem("cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("products", JSON.stringify(products)); }, [products]);
  useEffect(() => { localStorage.setItem("reviews", JSON.stringify(reviews)); }, [reviews]);
  
  // حفظ كلمة السر وحالة الدخول
  useEffect(() => { localStorage.setItem("adminPass", adminPass); }, [adminPass]);
  useEffect(() => { localStorage.setItem("isAdmin", isAdmin); }, [isAdmin]);

  // الدوال
  const addToCart = (product) => { setCart([...cart, product]); alert(t[lang].added); };
  const clearCart = () => setCart([]);
  const handleCheckout = () => { alert("تم استلام الطلب! سنتواصل معك."); setCart([]); setPage('home'); };
  const addNewOrder = (o) => { setAllOrders([...allOrders, o]); alert("تم!"); };
  const updateOrderStatus = (id, s) => { setAllOrders(allOrders.map(o => o.id === id ? { ...o, status: s } : o)); };
  const addNewProduct = (p) => { setProducts([...products, p]); };
  const deleteProduct = (id) => { if(window.confirm("حذف؟")) setProducts(products.filter(p => p.id !== id)); };
  const addNewReview = (r) => { setReviews([...reviews, r]); };
  const deleteReview = (id) => { setReviews(reviews.filter(r => r.id !== id)); };

  // دالة تغيير كلمة السر
  const changePassword = (p) => { 
    setAdminPass(p); 
    alert("تم تغيير كلمة السر بنجاح! يرجى حفظها: " + p); 
  };
  
  // دالة تسجيل الدخول المحسنة
  const handleAdminLogin = () => { 
    const inputPass = prompt("أدخل كلمة المرور:");
    if(inputPass === adminPass) { 
      setIsAdmin(true); 
      setPage('admin'); 
    } else { 
      alert("خطأ! كلمة المرور غير صحيحة."); 
    } 
  };

  const handleAdminClick = () => { 
    if (isAdmin) { setPage('admin'); } else { handleAdminLogin(); } 
  };

  // دالة التنقل والفلترة
  const handleNavigate = (targetPage) => { setPage(targetPage); };
  const getFilteredProducts = () => {
    if (page === 'imei') return products.filter(p => p.category && (p.category.includes('Unlock') || p.category.includes('IMEI')));
    if (page === 'server') return products.filter(p => p.category && p.category.includes('Server'));
    return products;
  };

  const glassCardStyle = { background: 'rgba(255, 255, 255, 0.1)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.2)', padding: '30px', borderRadius: '15px', textAlign: 'center', color: 'white', flex: 1, minWidth: '200px', cursor: 'pointer', transition: '0.3s' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'Segoe UI, sans-serif', backgroundColor: '#f1f5f9' }}>
      <Header cartCount={cart.length} onOpenCart={() => setPage('cart')} onAdminClick={handleAdminClick} onNavigate={handleNavigate} />
      {page === 'home' && <div style={{ background: '#000' }}><ImageSlider /></div>}
      <Ticker />

      <div style={{ flex: 1 }}>
        {page === 'home' && (
          <div>
            <div style={{ background: 'linear-gradient(rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.8)), url("https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=1920")', backgroundSize: 'cover', backgroundPosition: 'center', padding: '60px 20px', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: '50px', minHeight: '400px' }}>
              <div style={{ flex: 1, maxWidth: '600px', color: 'white' }}>
                <h1 style={{ fontSize: '48px', margin: '0 0 20px 0', lineHeight: '1.2' }}>Welcome to <span style={{ background: '#f59e0b', color: 'black', padding: '0 10px' }}>CPE Tech</span></h1>
                <p style={{ fontSize: '18px', opacity: 0.9 }}>المنصة الأولى لخدمات الـ Software وتخطي الحسابات.</p>
                <div style={{ marginTop: '30px', display: 'flex', gap: '15px' }}>
                  <button onClick={() => setPage('store')} style={{ background: '#f59e0b', color: 'black', border: 'none', padding: '12px 30px', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}>🛒 جميع الخدمات</button>
                  <button onClick={() => setPage('tracking')} style={{ background: 'transparent', color: 'white', border: '2px solid white', padding: '12px 30px', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}>🔍 تتبع طلبي</button>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', maxWidth: '600px' }}>
                <div style={glassCardStyle} onClick={() => setPage('bookRepair')}><div style={{ fontSize: '40px', marginBottom: '10px' }}>🎧</div><h3>24/7</h3><p>دعم فني</p></div>
                <div style={glassCardStyle} onClick={() => setPage('imei')}><div style={{ fontSize: '40px', marginBottom: '10px' }}>🔓</div><h3>IMEI</h3><p>خدمات فتح</p></div>
                <div style={glassCardStyle} onClick={() => setPage('server')}><div style={{ fontSize: '40px', marginBottom: '10px' }}>🌍</div><h3>Server</h3><p>سيرفرات</p></div>
              </div>
            </div>
            <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
               <Reviews darkMode={false} reviewsList={reviews || []} />
            </div>
          </div>
        )}

        {page !== 'home' && (
          <div style={{ maxWidth: '1200px', margin: '20px auto', padding: '20px' }}>
            {page === 'imei' && <h2 style={{color: '#1e3a8a', borderBottom: '2px solid #f59e0b', paddingBottom: '10px'}}>🔓 خدمات IMEI وفتح الشبكات</h2>}
            {page === 'server' && <h2 style={{color: '#1e3a8a', borderBottom: '2px solid #f59e0b', paddingBottom: '10px'}}>🌍 خدمات السيرفرات والبوكسات</h2>}
            <button onClick={() => setPage('home')} style={{ marginBottom: '20px', padding: '10px 20px', cursor:'pointer' }}>⬅️ عودة</button>
            {(page === 'store' || page === 'imei' || page === 'server') && <Store products={getFilteredProducts()} onAddToCart={addToCart} />}
            {page === 'cart' && <Cart cartItems={cart} onClearCart={clearCart} onCheckout={handleCheckout} />}
            {page === 'tracking' && <Tracking orders={allOrders} />}
            {/* تم التأكد من تمرير reviews بشكل صحيح */}
            {page === 'admin' && isAdmin && 
              <AdminPanel 
                orders={allOrders} onAddOrder={addNewOrder} onUpdateStatus={updateOrderStatus} 
                products={products} onAddProduct={addNewProduct} onDeleteProduct={deleteProduct} 
                reviews={reviews} onAddReview={addNewReview} onDeleteReview={deleteReview} 
                onChangePassword={changePassword} 
              />
            }
          </div>
        )}
      </div>
      <Footer />
      <div style={{ position: 'fixed', left: '0', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <a href="#" style={{ background: '#3b5998', color: 'white', padding: '10px', textDecoration: 'none', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '0 5px 5px 0' }}>F</a>
        <a href="#" style={{ background: '#0088cc', color: 'white', padding: '10px', textDecoration: 'none', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '0 5px 5px 0' }}>T</a>
      </div>
      <FloatingWhatsApp />
    </div>
  );
}

export default App;